import './UserTermsandCondition.css'
import Header from '../Header/Navbar'
import Footer from '../Footer/Footer';



const TermsAndConditionsPage:React.FC = () => {
  return (
    <>
    
    <div className="termsConditionsSection">
      <h2>User Terms & Conditions</h2>
      <p style={{ marginLeft: "10px" }}>
        Operated by Ganga Supermarket | Built using Abantecart | Hosted on Google.com
      </p>

      <h3>1. Acceptance of Terms</h3>
      <ul>
        <li>By accessing or using the website, you agree to be bound by these Terms & Conditions.</li>
        <li>If you do not agree, you may not use the services.</li>
        <li>You must also accept the Privacy Policy and Returns Policy.</li>
        <li>Terms are subject to updates; continued use implies acceptance of changes.</li>
      </ul>

      <h3>2. Account Terms</h3>
      <ul>
        <li>You must be 18+ or of legal age in your region to use the service.</li>
        <li>You agree to provide accurate and current information while registering.</li>
        <li>Ganga Supermarket reserves the right to suspend or terminate accounts at its discretion.</li>
        <li>You are responsible for safeguarding your login credentials and all transactions made from your account.</li>
        <li>Do not share or use another user's credentials.</li>
      </ul>

      <h3>3. User Obligations</h3>
      <ul>
        <li>You must comply with Indian IT Act 2000 and applicable laws.</li>
        <li>You must not:
          <ul>
            <li>Use the service for unlawful purposes.</li>
            <li>Upload malware or perform malicious acts.</li>
            <li>Attempt unauthorized access or disrupt operations.</li>
            <li>Infringe on intellectual property rights.</li>
            <li>Submit false or misleading information.</li>
          </ul>
        </li>
      </ul>

      <h3>4. Product Information & Orders</h3>
      <ul>
        <li>Placing an order does not confirm acceptance — confirmation will be sent via email.</li>
        <li>Products are sold for personal use, not resale (B2B available at b2b.gangasupermarket.in).</li>
        <li>We reserve rights to:
          <ul>
            <li>Limit/cancel orders or quantities.</li>
            <li>Change product pricing or availability without notice.</li>
          </ul>
        </li>
        <li>Returns, refunds, and cancellations follow our dedicated policies.</li>
      </ul>

      <h3>5. Taxes</h3>
      <ul>
        <li>All applicable taxes (GST/VAT/cess) are the responsibility of the customer.</li>
      </ul>

      <h3>6. Communication</h3>
      <ul>
        <li>You agree to receive communications via email, SMS, WhatsApp, and other electronic modes.</li>
      </ul>

      <h3>7. Copyrights & Trademarks</h3>
      <ul>
        <li>All content (logos, text, graphics) is protected and cannot be reused without permission.</li>
        <li>Any unauthorized use may invite legal action.</li>
      </ul>

      <h3>8. Indemnification & Liability</h3>
      <ul>
        <li>We are not liable for indirect, incidental, or consequential damages.</li>
        <li>Our maximum liability is limited to the refund of purchase value (if applicable).</li>
        <li>You agree to indemnify Ganga Supermarket from any third-party claims due to your breach.</li>
      </ul>

      <h3>9. Termination</h3>
      <ul>
        <li>Either party can terminate these terms at any time.</li>
        <li>We may terminate service without notice if terms are violated.</li>
      </ul>

      <h3>10. Governing Law</h3>
      <ul>
        <li>These terms are governed by the laws of India.</li>
        <li>Jurisdiction: Namakkal, Tamil Nadu, India.</li>
      </ul>

      <h3>11. Miscellaneous</h3>
      <ul>
        <li>No waiver of rights if we do not act on a breach immediately.</li>
        <li>Complaints must be submitted within 7 days of delivery.</li>
      </ul>
    </div>
    <Footer/>
    </>
  );
};

export default TermsAndConditionsPage;
